document.addEventListener('DOMContentLoaded', () => {
  CF.ready(function() {
    const $myForm = document.querySelector('form[data-cf-form="v3tWzR"]');

    $myForm.addEventListener('cf:step_changed', function(event) {
      const value = $myForm.cfForm.getFieldValue('siret');
      const fromIndex = event.detail.fromIndex;
      const toIndex = event.detail.toIndex;

      if (!value || fromIndex !== 0 || toIndex !== 1) {
        return;
      }

      const url = document.querySelector('div.api-url-container').getAttribute('data-api-url');
      fetch(url + '/api-insee/' + value, {
        method: 'GET',
      }).then(response => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 404) {
          throw new Error('Unknown insee code');
        }
      }).then(json => {
        const company = json.companyName;
        $myForm.cfForm.setFieldValue('default_address.company', company);

        const street = json.street;
        $myForm.cfForm.setFieldValue('default_address.address1', street);

        const city = json.city;
        $myForm.cfForm.setFieldValue('default_address.city', city);

        const zipcode = json.zipcode;
        $myForm.cfForm.setFieldValue('default_address.zip', zipcode);
      }).catch(error => {
        console.error(error);
      });
    });
  });
});
